module.exports = __webpack_public_path__ + "static/img/logo-inverted.c3fd8161.svg";